/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  function openSpectraWelcomeOffer(event) {
    var link = event.target.closest('a[href*="#newsletter-popup"]');
    if (!link) return;

    var popup = document.querySelector('.NewsletterPopup[data-section-type="newsletter-popup"]');
    if (!popup) return;

    event.preventDefault();
    popup.setAttribute('aria-hidden', 'false');

    try {
      window.localStorage.setItem('themePopup', 'true');
    } catch (error) {
      // The offer should still open when browser storage is unavailable.
    }

    var firstField = popup.querySelector('input[name="contact[first_name]"]');
    if (firstField) {
      window.setTimeout(function () {
        firstField.focus();
      }, 250);
    }
  }

  document.addEventListener('click', openSpectraWelcomeOffer);

  document.addEventListener('DOMContentLoaded', function () {
    var parameters = new URLSearchParams(window.location.search);

    if (window.location.hash === '#newsletter-popup' || parameters.get('welcome') === '1') {
      var popup = document.querySelector('.NewsletterPopup[data-section-type="newsletter-popup"]');
      if (popup) popup.setAttribute('aria-hidden', 'false');
    }
  });

  function numberValue(input) {
    return Math.max(0, parseFloat(input && input.value) || 0);
  }

  function formatArea(value) {
    return value.toFixed(2);
  }

  function initTileCalculator(calculator) {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    var coverage = parseFloat(calculator.dataset.boxCoverage) || 1.44;
    var toggle = calculator.querySelector('.SpectraTileCalculator__Toggle');
    var panel = calculator.querySelector('.SpectraTileCalculator__Panel');
    var toggleIcon = calculator.querySelector('.SpectraTileCalculator__ToggleIcon');
    var rooms = calculator.querySelector('[data-calculator-rooms]');
    var addRoom = calculator.querySelector('[data-add-calculator-room]');
    var waste = calculator.querySelector('[data-calculator-waste]');
    var apply = calculator.querySelector('[data-apply-calculation]');
    var areaInput = calculator.querySelector('[data-required-area]');
    var quantityInput = calculator.querySelector('[data-box-quantity]');
    var mode = 'floor';
    var result = { area: 0, boxes: 0, supplied: 0 };

    function setText(selector, value) {
      var element = calculator.querySelector(selector);
      if (element) element.textContent = value;
    }

    function syncOrderQuantity() {
      var requestedArea = Math.max(0.01, numberValue(areaInput));
      var boxes = Math.max(1, Math.ceil((requestedArea - 0.000001) / coverage));
      var supplied = boxes * coverage;

      quantityInput.value = boxes;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      setText('[data-order-boxes]', boxes);
      setText('[data-order-box-label]', boxes === 1 ? 'box' : 'boxes');
      setText('[data-order-supplied]', formatArea(supplied));
    }

    function calculate() {
      var area = 0;

      rooms.querySelectorAll('[data-calculator-room]').forEach(function (room) {
        var length = numberValue(room.querySelector('[data-room-length]'));
        var width = numberValue(room.querySelector('[data-room-width]'));
        var height = numberValue(room.querySelector('[data-room-height]'));

        if (mode === 'walls') {
          area += 2 * (length + width) * height;
        } else {
          area += length * width;
        }
      });

      var wasteRate = numberValue(waste) / 100;
      var areaWithWaste = area * (1 + wasteRate);
      var boxes = areaWithWaste > 0 ? Math.ceil((areaWithWaste - 0.000001) / coverage) : 0;
      var supplied = boxes * coverage;
      result = { area: areaWithWaste, boxes: boxes, supplied: supplied };

      setText('[data-calculated-area]', formatArea(areaWithWaste));
      setText('[data-calculated-boxes]', boxes);
      setText('[data-calculated-supplied]', formatArea(supplied));
      apply.disabled = boxes === 0;
    }

    function updateRoomLabels() {
      rooms.querySelectorAll('[data-calculator-room]').forEach(function (room, index) {
        room.querySelector('legend').textContent = 'Room ' + (index + 1);
      });
    }

    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      toggleIcon.textContent = willOpen ? '−' : '+';
    });

    calculator.querySelectorAll('[data-calculator-mode]').forEach(function (button) {
      button.addEventListener('click', function () {
        mode = button.dataset.calculatorMode;
        calculator.querySelectorAll('[data-calculator-mode]').forEach(function (tab) {
          var selected = tab === button;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        rooms.querySelectorAll('.SpectraTileCalculator__Height').forEach(function (field) {
          field.hidden = mode !== 'walls';
        });
        calculate();
      });
    });

    addRoom.addEventListener('click', function () {
      var newRoom = rooms.querySelector('[data-calculator-room]').cloneNode(true);
      newRoom.querySelectorAll('input').forEach(function (input) { input.value = ''; });
      newRoom.querySelector('.SpectraTileCalculator__Height').hidden = mode !== 'walls';
      rooms.appendChild(newRoom);
      updateRoomLabels();
      calculate();
    });

    rooms.addEventListener('input', calculate);
    waste.addEventListener('change', calculate);
    areaInput.addEventListener('input', syncOrderQuantity);
    areaInput.addEventListener('change', syncOrderQuantity);

    apply.addEventListener('click', function () {
      areaInput.value = formatArea(result.area);
      syncOrderQuantity();
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggleIcon.textContent = '+';
      areaInput.focus();
    });

    calculate();
    syncOrderQuantity();
  }

  function initAllTileCalculators(root) {
    (root || document).querySelectorAll('.SpectraTileCalculator').forEach(initTileCalculator);
  }

  function initLarsenCalculator(calculator) {
    if (calculator.dataset.initialized === 'true') return;
    calculator.dataset.initialized = 'true';

    var kind = calculator.dataset.calculatorKind;
    var toggle = calculator.querySelector('.SpectraLarsenCalculator__Toggle');
    var panel = calculator.querySelector('.SpectraLarsenCalculator__Panel');
    var icon = calculator.querySelector('.SpectraLarsenCalculator__ToggleIcon');
    var resultElement = calculator.querySelector('[data-larsen-result]');
    var detailElement = calculator.querySelector('[data-larsen-detail]');
    var apply = calculator.querySelector('[data-larsen-apply]');
    var quantity = calculator.querySelector('[data-larsen-quantity]');
    var recommended = 0;

    function value(selector) {
      return numberValue(calculator.querySelector(selector));
    }

    function calculate() {
      var detail = 'Enter your measurements to calculate.';

      if (kind === 'adhesive') {
        var area = value('[data-larsen-area]');
        var allowance = value('[data-larsen-waste]') / 100;
        recommended = area > 0 ? Math.ceil((area * (1 + allowance)) / 3) : 0;
        if (recommended) {
          detail = 'Covers up to ' + (recommended * 3).toFixed(0) + 'm² using our conservative 3m²-per-bag ordering allowance.';
        }
      } else if (kind === 'grout') {
        var groutArea = value('[data-larsen-area]');
        var tileLength = value('[data-tile-length]');
        var tileWidth = value('[data-tile-width]');
        var tileDepth = value('[data-tile-depth]');
        var jointWidth = value('[data-joint-width]');
        var kilograms = 0;

        if (groutArea && tileLength && tileWidth && tileDepth && jointWidth) {
          kilograms = groutArea * ((tileLength + tileWidth) / (tileLength * tileWidth)) * tileDepth * jointWidth * 1.6 * 1.10;
        }
        recommended = kilograms > 0 ? Math.ceil(kilograms / 3) : 0;
        if (recommended) {
          detail = 'Estimated use: ' + kilograms.toFixed(2) + 'kg including a 10% allowance. Supplied in full 3kg packs.';
        }
      } else if (kind === 'silicone') {
        var jointLength = value('[data-joint-length]');
        var width = value('[data-joint-width]');
        var depth = value('[data-joint-depth]');
        var millilitres = jointLength * width * depth;
        recommended = millilitres > 0 ? Math.ceil((millilitres * 1.10) / 300) : 0;
        if (recommended) {
          var metresPerCartridge = 300 / (width * depth);
          detail = 'Approx. ' + metresPerCartridge.toFixed(1) + ' linear metres per cartridge at this bead size before the application allowance.';
        }
      }

      resultElement.textContent = recommended;
      detailElement.textContent = detail;
      apply.disabled = recommended === 0;
    }

    toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      icon.textContent = willOpen ? '−' : '+';
    });

    panel.addEventListener('input', calculate);
    panel.addEventListener('change', calculate);
    apply.addEventListener('click', function () {
      quantity.value = Math.max(1, recommended);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';
      quantity.focus();
    });

    calculate();
  }

  function initAllLarsenCalculators(root) {
    (root || document).querySelectorAll('[data-larsen-calculator]').forEach(initLarsenCalculator);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllTileCalculators(document);
    initAllLarsenCalculators(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllTileCalculators(event.target);
    initAllLarsenCalculators(event.target);
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-spectra-selected-variant]').forEach(function (element) {
      element.textContent = variant.title;
    });
  });

  document.addEventListener('click', function (event) {
    var stickyButton = event.target.closest('[data-sticky-add-to-cart]');
    if (!stickyButton) return;

    var productForm = stickyButton.closest('.ProductForm');
    var addToCartButton = productForm && productForm.querySelector('[data-action="add-to-cart"]');
    if (addToCartButton && !addToCartButton.disabled) addToCartButton.click();
  });
})();
